export default __webpack_public_path__ + "static/banner-1-25029b7d26bcc5b273effd86e42e353b.jpg";